import apiTool from './index';

const GET_COMPANIES_URL = 'company/get-companies/';
const GET_HIERARCHICAL_COMPANIES_URL = 'company/get-hierarchical-companies/';
const ADD_COMPANY_URL = 'company/add-company/';
const GET_COMPANIES_WITHOUT_SURVEY = 'company/get-companies-without-survey/';
const GET_COMPANIES_WITHOUT_MANAGER = 'company/get-companies-without-manager/';
const GET_PERIMETER_STRUCTURE = 'company/generate-perimeter-structure/';

export default {
  getCompanies() {
    return apiTool.get(GET_COMPANIES_URL);
  },
  getHierarchicalCompanies() {
    return apiTool.get(GET_HIERARCHICAL_COMPANIES_URL);
  },
  addCompany(payload) {
    return apiTool.post(ADD_COMPANY_URL, payload);
  },
  getCompaniesWithoutSurvey(payload) {
    return apiTool.post(GET_COMPANIES_WITHOUT_SURVEY, payload);
  },
  getCompaniesWithoutManager(payload) {
    return apiTool.post(GET_COMPANIES_WITHOUT_MANAGER, payload);
  },
  getPerimeterStructure(payload) {
    return apiTool.post(GET_PERIMETER_STRUCTURE, payload);
  },
};
